import { jsx as _jsx } from "react/jsx-runtime";
import cx from "classnames";
import { DEFAULT_GRADIENT_ID, GRADIENT_IDS } from "./svg-gradient";
import baseStyles from "./svg.module.css";
var SVG = function(param) {
    var className = param.className, fill = param.fill, _stroke = param.stroke, stroke = _stroke === void 0 ? "none" : _stroke, size = param.size, width = param.width, height = param.height, children = param.children, preserveAspectRatio = param.preserveAspectRatio, verticalAlign = param.verticalAlign, styles = param.styles, _hasGradient = param.hasGradient, hasGradient = _hasGradient === void 0 ? false : _hasGradient, _gradientId = param.gradientId, gradientId = _gradientId === void 0 ? DEFAULT_GRADIENT_ID : _gradientId, dataTestId = param.dataTestId;
    var finalHeight = size || height;
    var finalWidth = size || width;
    var gradientFill = hasGradient ? "url(#".concat(GRADIENT_IDS[gradientId], ")") : "";
    var Icon = children;
    return /*#__PURE__*/ _jsx("span", {
        className: cx(baseStyles.container, [
            className,
            styles && styles.svg
        ]),
        style: {
            height: finalHeight,
            width: finalWidth
        },
        "aria-hidden": "true",
        "data-testid": dataTestId,
        children: /*#__PURE__*/ _jsx(Icon, {
            preserveAspectRatio: preserveAspectRatio,
            height: finalHeight,
            width: finalWidth,
            fill: hasGradient ? gradientFill : fill,
            style: {
                display: "flex",
                width: finalWidth,
                height: finalHeight,
                fill: hasGradient ? gradientFill : fill,
                stroke: stroke,
                verticalAlign: verticalAlign
            }
        })
    });
};
SVG.defaultProps = {
    hasGradient: false,
    size: undefined,
    width: "100%",
    height: "100%",
    className: "",
    preserveAspectRatio: "xMidYMid",
    fill: "currentColor",
    verticalAlign: "middle",
    styles: {}
};
export default SVG;
